<template>
  <div class="app-toolkit">
    <base-panel
      additional-body-classes="app-toolkit__body"
      additional-classes="app-toolkit__panel"
      additional-heading-classes="app-toolkit--big"
    >

      <template #heading>
        <slot />
      </template>
      <div class="form">
        <div class="app-toolkit--big app-toolkit__input">
          <div class="filter-tags">
            <label
              class="filter-tags__tag"
            >
              <input
                id="all"
                v-model="selectedTag"
                type="radio"
                value="all"
              >
              <span class="filter-tags__tag-label">
                alle
              </span>
            </label>
            <label
              v-for="(tagName, tagKey) in tagGroupOneMap"
              :key="tagKey"
              class="filter-tags__tag"
            >
              <input
                :id="tagKey"
                v-model="selectedTag"
                type="radio"
                :value="tagKey"
              >
              <span class="filter-tags__tag-label">
                {{ tagName }}
              </span>
            </label>
          </div>
            <div class="filter-tags">

            <label
                      v-for="(tagName, tagKey) in tagGroupTwoMap"
                      :key="tagKey"
                      class="filter-tags__tag"
              >
                  <input
                          :id="tagKey"
                          v-model="selectedTag"
                          type="radio"
                          :value="tagKey"
                  >
                  <span class="filter-tags__tag-label">
                {{ tagName }}
              </span>
              </label>
          </div>
        </div>
        <draggable
          class="app-toolkit__list dragArea row"
          :fallback-tolerance="1"
          :force-fallback="true"
          ghost="ghost"
          :group="{ name: 'areas', put: false, pull: 'clone'}"
          handle=".handle"
          :list="displayAreas"
          :sort="false"
          @end="$store.commit('endConnectingDrag')"
          @start="$store.commit('startConnectingDrag')"
          :disabled="disableDraggable"
        >
          <div
            v-for="element in displayAreas"
            :key="element.identifier"
            class="app-toolkit__item col-lg-4"
          >
            <app-toolkit-item
              @add-element-manually="$emit('add-element-manually', $event)"
              :element="element"
              :identifier="element.identifier"
            />
          </div>
        </draggable>
      </div>
    </base-panel>
  </div>
</template>

<script>
import {VueDraggableNext} from 'vue-draggable-next'
import BasePanel from '@/components/BasePanel.vue';
import BaseButton from '@/components/BaseButton.vue';
import AppToolkitItem from '@/components/AppToolkitItem.vue';

/**
 * Die logische Komponente für das Filtern und die Auflistung der Wireframes für verfügbare Areas - Der Baukasten
 * @displayName AppToolkit
 */
export default {
  name: 'AppToolkit',
  components: {
    AppToolkitItem,
    draggable: VueDraggableNext,
    BasePanel,
    BaseButton
  },
  props: {
    configuredAreas: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedTag: 'all',
      selection: [],
      tagGroupOneMap: {
        basisbox: 'Basis BILD',
        basistext: 'Basis TEXT',
        basismix: 'Basis MIX',
      },
      tagGroupTwoMap: {
        //cta: 'CTA', // possibly deprecated
        content: 'Text',
        image: 'Bild',
        video: 'Video',
        reference: 'Referenz',
        boxes: 'Boxen',
        cta: 'Highlight',
        listing: 'Liste',
        teaser: 'Teaser',
        ch: 'Contentpool',
      },
    }
  },
  computed: {
    disableDraggable() {
      return window.innerWidth < 992
    },
    wireframesNamesForGraphics() {
      let finalString = '';

      Object.keys(this.configuredAreas).forEach((identifier) => {
        let string = identifier.replaceAll('-','_');
        let area = this.configuredAreas[identifier];

        finalString += '<br><br>';
        finalString += '<b>';
        finalString += string;
        finalString += ':</b>';
        finalString += '<br>';
        finalString += string;

        Object.keys(area.elements).forEach(key => {
          let element = area.elements[key];

          // this marks it as a setting (to be grouped at the top of the area)
          if (   element.type === 'dropdown'
              && typeof element.settings !== 'undefined'
              && typeof element.settings.backend !== 'undefined'
              && typeof element.settings.backend.cssClass != 'undefined'
              && element.settings.backend.cssClass == 'js-collect_neighbours_into_one'
              && element.settings.preview) {

            finalString += '--{'
            finalString += element.lang.title;
            finalString += '}';
           }
        })

        finalString += '.png';
        finalString += '<br>';
        finalString += 'wobei:';

        Object.keys(area.elements).forEach(key => {
          let element = area.elements[key];
          // this marks it as a setting (to be grouped at the top of the area)
          if (   element.type === 'dropdown'
            && typeof element.settings !== 'undefined'
            && typeof element.settings.backend !== 'undefined'
            && typeof element.settings.backend.cssClass != 'undefined'
            && element.settings.backend.cssClass == 'js-collect_neighbours_into_one'
            && element.settings.preview) {

            finalString += '<br><br>';
            finalString += '<b>Optionen für ';
            finalString += element.lang.title;
            finalString += ':</b>';
            finalString += '<br>';

            Object.keys(element.settings.options).forEach((option) => {
              finalString += '* ';
              finalString += option;
              finalString += '<br>';
            })
          }
        })
      })

      return finalString
    },
    displayAreas() {
      let finalArray = [];

      if (this.selectedTag === 'all') {
        // return this.configuredAreas as array
        Object.keys(this.configuredAreas).forEach((key) => {
          let obj = this.configuredAreas[key];

          obj.identifier = key;
          obj.entry = this.$store.state.entry;
          obj.id = 'new_area_' + key;
          obj.content = '';
          // the selection will hold settings made for the item by AppToolkitItem.vue
          obj.selection = {};


          finalArray.push(obj)
        })

        return finalArray
      }

      Object.keys(this.configuredAreas).forEach((key) => {
        if (typeof this.configuredAreas[key].settings.tags !== 'undefined') {
          this.configuredAreas[key].settings.tags.every((tag) => {
            if (this.$store.state.debug) {
              console.log(tag);
              console.log(this.selection.includes(tag));
            }

            if (this.selectedTag === tag) {
              let obj = this.configuredAreas[key];
              obj.identifier = key;

              finalArray.push(obj);
              return false
            }

            return true
          })
        }
      })

      return finalArray;
    },
    tags() {
      let allTags = [],
        uniqueTags,
        tagObjects = [];

      Object.keys(this.configuredAreas).forEach((key) => {
        if (typeof this.configuredAreas[key].settings.tags !== 'undefined') {
          if (this.$store.state.debug) {
            console.log(allTags);
            console.log(this.configuredAreas[key].settings.tags);
          }
          allTags = allTags.concat(this.configuredAreas[key].settings.tags)
        }
      })

      uniqueTags = allTags.filter(function (item, pos, self) {
        return self.indexOf(item) == pos;
      })

      if (this.$store.state.debug) {
        console.log(uniqueTags);
      }

      uniqueTags.forEach((tag) => {
        let obj = {};
        obj.label = this.tagMap[tag];
        obj.value = tag;
        tagObjects.push(obj);
      })

      if (this.$store.state.debug) {
        console.log(tagObjects);
      }

      return tagObjects;
    }
  }
}
</script>

<style lang="less">
.app-toolkit {
  @media (min-width: 992px) {
    position: sticky;
    top: 30px;
    bottom: 110px;

    &--big {
      display: block !important;
    }

    &--small {
      display: none !important;
    }
  }

  @media (max-width: 991px) {
    &__mobil {
      position: sticky;
      max-height: 45vh;
      bottom: 46px;
      padding: 0;
      z-index: 9999;
    }

    &--big {
      display: none !important;
    }

    &--small {
      display: block !important;
    }
  }

  @media (max-width: 767px) {
    &__mobil {
      bottom: 0;
    }
  }

  z-index: 9999;

  &__row {
    position: relative;
  }

  &__panel {
    background-color: #d6e7f5 !important;
    border-color: transparent;
    border-radius: 30px;
    padding: 30px;
    margin-bottom: 0;

    @media (max-width: 991px) {
      border-radius: 0;
      margin-bottom: 0;
      padding: 0;
    }

    & > .panel-heading {
      background-color: #d6e7f5;
      background-image: none;
      padding-bottom: 5px;

      @media (max-width: 991px) {
        .panel-title {
          font-size: 1.6rem;
          line-height: 2;
        }

        small {
          display: none;
        }
      }

      hr {
        margin: 10px 0;
        border-top: 1px solid #0375a6;

        @media (max-width: 991px) {
          display: none;
        }
      }
      //color: #5891a7;
    }
  }

  &__body {
    max-height: calc(100vh - 270px);
    overflow-y: scroll;
    overflow-x: hidden;

    position: relative;
    padding-top: 0;

    @media (max-width: 991px) {
      overflow-y: hidden;
      overflow-x: scroll;
      padding-top: 15px;
    }
  }

  &__input {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;

    background-color: #d6e7f5;
    outline: 5px solid #d6e7f5;
    margin-bottom: 0;

    &:after {
      content: '';
      display: block;

      position: absolute;
      top: 100%;
      left: -5px;
      right: -5px;
      z-index: 1;
      height: 2rem;

      background: #d6e7f5;
      background: linear-gradient(180deg, rgba(214,231,245,1) 0%, rgba(214,231,245,0.8561799719887955) 48%, rgba(214,231,245,0) 100%);
    }
  }

  &__list {
    padding-top: 15px;

    @media (max-width: 991px) {
      padding-top: 0;
      flex-direction: row;
      flex-wrap: nowrap;
      margin: 0;
    }
  }

  &__item {
    @media (max-width: 991px) {
      max-width: 125px;
      padding: 0 3px;
      flex-shrink: 0;
      align-content: stretch;
      align-items: flex-end;

      &:last-child {
        padding-right: 15px;
      }

      .panel--minimal {
        margin-bottom: 0;
        border: 0 !important;
        background-color: #ffffff42;

        .handle {
          display: flex;
          height: 109px;
          align-content: center;
          align-items: center;
        }

        .panel-footer {
          display: none;
        }
      }
    }
  }
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 15px;

  &__tag {
    display: flex;
    text-align: center;
    font-weight: normal;
    margin: 0;

    input[type="radio"] {
      display: none;
    }

    input[type="radio"]:checked ~ .filter-tags__tag-label {
      background-color: #0375a6; //$main-color
      color: #fff;

      &:hover {
        background-color: #349691;
      }
    }
  }

  &__tag-label {
    padding: 5px 10px;
    background-color: #fff;
    border: 1px solid #0375a6; //$main-color
    border-radius: 50px;
    color: #0375a6;
    font-size: 11px;
    line-height: 1;

    &:hover {
      cursor: pointer;
      background-color: #e2f0ef; //$color-mint
      border: 1px solid #349691; //$color-mint-light
    }
  }
}

.row.small-gutters {
  margin: 0 -2px;

  .small-gutters.col-xs-1, .small-gutters.col-sm-1, .small-gutters.col-md-1, .small-gutters.col-lg-1, .small-gutters.col-xs-2, .small-gutters.col-sm-2, .small-gutters.col-md-2, .small-gutters.col-lg-2, .small-gutters.col-xs-3, .small-gutters.col-sm-3,
  .small-gutters.col-md-3, .small-gutters.col-lg-3, .small-gutters.col-xs-4, .small-gutters.col-sm-4, .small-gutters.col-md-4, .small-gutters.col-lg-4, .small-gutters.col-xs-5, .small-gutters.col-sm-5, .small-gutters.col-md-5, .small-gutters.col-lg-5,
  .small-gutters.col-xs-6, .small-gutters.col-sm-6, .small-gutters.col-md-6, .small-gutters.col-lg-6, .small-gutters.col-xs-7, .small-gutters.col-sm-7, .small-gutters.col-md-7, .small-gutters.col-lg-7, .small-gutters.col-xs-8, .small-gutters.col-sm-8,
  .small-gutters.col-md-8, .small-gutters.col-lg-8, .small-gutters.col-xs-9, .small-gutters.col-sm-9, .small-gutters.col-md-9, .small-gutters.col-lg-9, .small-gutters.col-xs-10, .small-gutters.col-sm-10, .small-gutters.col-md-10, .small-gutters.col-lg-10,
  .small-gutters.col-xs-11, .small-gutters.col-sm-11, .small-gutters.col-md-11, .small-gutters.col-lg-11, .small-gutters.col-xs-12, .small-gutters.col-sm-12, .small-gutters.col-md-12, .small-gutters.col-lg-12 {
    padding: 0 2px;
  }
}

.panel-small {
  .panel-heading,
  .panel-body,
  .panel-footer {
    padding: 5px;
  }
}

.sortable-ghost .panel,
.sortable-ghost.panel
{
  outline: 2px dashed #337ab7;
  outline-offset: 2px;
  z-index: 3;
  position: relative;

  * {
    background-color: #337ab7 !important;
    opacity: 0.2;
    color: #337ab7 !important;
    border-color: transparent;
  }

  img {
    opacity: 0;
  }
}

/*  Bootstrap Clearfix */

/*  Tablet  */
@media (min-width:767px){

  /* Column clear fix */
  .col-lg-1:nth-child(12n+1),
  .col-lg-2:nth-child(6n+1),
  .col-lg-3:nth-child(4n+1),
  .col-lg-4:nth-child(3n+1),
  .col-lg-6:nth-child(2n+1),
  .col-md-1:nth-child(12n+1),
  .col-md-2:nth-child(6n+1),
  .col-md-3:nth-child(4n+1),
  .col-md-4:nth-child(3n+1),
  .col-md-6:nth-child(2n+1){
    clear: none;
  }
  .col-sm-1:nth-child(12n+1),
  .col-sm-2:nth-child(6n+1),
  .col-sm-3:nth-child(4n+1),
  .col-sm-4:nth-child(3n+1),
  .col-sm-6:nth-child(2n+1){
    clear: left;
  }
}


/*  Medium Desktop  */
@media (min-width:992px){

  /* Column clear fix */
  .col-lg-1:nth-child(12n+1),
  .col-lg-2:nth-child(6n+1),
  .col-lg-3:nth-child(4n+1),
  .col-lg-4:nth-child(3n+1),
  .col-lg-6:nth-child(2n+1),
  .col-sm-1:nth-child(12n+1),
  .col-sm-2:nth-child(6n+1),
  .col-sm-3:nth-child(4n+1),
  .col-sm-4:nth-child(3n+1),
  .col-sm-6:nth-child(2n+1){
    clear: none;
  }
  .col-md-1:nth-child(12n+1),
  .col-md-2:nth-child(6n+1),
  .col-md-3:nth-child(4n+1),
  .col-md-4:nth-child(3n+1),
  .col-md-6:nth-child(2n+1){
    clear: left;
  }
}


/*  Large Desktop  */
@media (min-width:1200px){

  /* Column clear fix */
  .col-md-1:nth-child(12n+1),
  .col-md-2:nth-child(6n+1),
  .col-md-3:nth-child(4n+1),
  .col-md-4:nth-child(3n+1),
  .col-md-6:nth-child(2n+1),
  .col-sm-1:nth-child(12n+1),
  .col-sm-2:nth-child(6n+1),
  .col-sm-3:nth-child(4n+1),
  .col-sm-4:nth-child(3n+1),
  .col-sm-6:nth-child(2n+1){
    clear: none;
  }
  .col-lg-1:nth-child(12n+1),
  .col-lg-2:nth-child(6n+1),
  .col-lg-3:nth-child(4n+1),
  .col-lg-4:nth-child(3n+1),
  .col-lg-6:nth-child(2n+1){
    clear: left;
  }
}

.show-toolkit-btn {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 99%;
  background-color: #5bc0de;
  padding: 15px;
  box-shadow: -2px 0px 3px #00000036;
  cursor: pointer;
  color: #fff;

  &:hover {
    color: #eee;
    background-color: #31b0d5;
  }

  &__text {
    transform: rotate(-90deg);
    overflow: visible;
    text-wrap: nowrap;
    transform-origin: center;
    position: absolute;
    width: 100px;
    height: 100px;
    left: 50%;
    top: 50%;
    margin-left: -8px;
    margin-top: 0;
    pointer-events: none;
  }
}
</style>
